import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import ExportTemplate from "@/router/modules/ExportTemplate/ExportTemplate";
import MitigationAction from "@/router/modules/MitigationAction/MitigationAction";
import PIARequest from "@/router/modules/PIARequest/PIARequest";
import DIARequest from "@/router/modules/DIARequest/DIARequest";
import Meeting from "@/router/modules/Meeting/Meeting";
import Topic from "@/router/modules/Topic/Topic";
import KpiModule from "@/modules/kpi";
import Task from "@/router/modules/StrategicPlan/Task/Task";
import Deliverable from "@/router/modules/StrategicPlan/Deliverable/Deliverable";
import StrategicPlan from "@/router/modules/StrategicPlan/StrategicPlan";
import StrategicPlanDetails from "@/router/modules/StrategicPlan/StrategicPlanDetails/StrategicPlanDetails";
import Program from "@/router/modules/StrategicPlan/Program/Program";
import GlossaryUpdateRequest from "@/router/modules/GlossaryUpdateRequest/GlossaryUpdateRequest";
import ObjectiveDetails from "@/router/modules/StrategicPlan/ObjectiveDetails/ObjectiveDetails";
import InitiativeDetails from "@/router/modules/StrategicPlan/InitiativeDetails/InitiativeDetails";
import DeliverableDetails from "@/router/modules/StrategicPlan/DeliverableDetails/DeliverableDetails";
import TaskDetails from "@/router/modules/StrategicPlan/TaskDetails/TaskDetails";
import ProgramDetails from "@/router/modules/StrategicPlan/ProgramDetails/ProgramDetails";
import Objective from "@/router/modules/StrategicPlan/Objective/Objective";
import GlossaryVersion from "@/router/modules/GlossaryVersion/GlossaryVersion";
import ObjectiveType from "@/router/modules/StrategicPlan/ObjectiveType/ObjectiveType";
import RequirementType from "@/router/modules/RequirementType/RequirementType";
import DomainControl from "@/router/modules/DomainControl/DomainControl";
import DataProduct from "@/router/modules/DataProduct/DataProduct";
import Classification from "@/router/modules/Classification/Classification";
import Glossary from "@/router/modules/Glossary/Glossary";
import Term from "@/router/modules/Term/Term";
import Initiative from "@/router/modules/StrategicPlan/Initiative/Initiative";
import Project from "@/router/modules/StrategicPlan/Project/Project";
import ProjectDetails from "@/router/modules/StrategicPlan/ProjectDetails/ProjectDetails";
import Milestone from "@/router/modules/StrategicPlan/Milestone/Milestone";
import MilestoneDetails from "@/router/modules/StrategicPlan/MilestoneDetails/MilestoneDetails";
import DatabaseServiceInsight from "@/router/modules/DatabaseServiceInsight/DatabaseServiceInsight";
import DatabaseService from "@/router/modules/DatabaseService/DatabaseService";
import DataCatalog from "@/router/modules/DataCatalog/DataCatalog";
import DatabaseInsights from "@/router/modules/DatabaseInsights/DatabaseInsights";
import DatabaseTables from "@/router/modules/DatabaseTables/DatabaseTables";
import DatabaseColumns from "@/router/modules/DatabaseColumns/DatabaseColumns";
import Reports from "@/router/modules/Reports/Reports";
import Committee from "@/router/modules/Committee/Committee";
import Agenda from "@/router/modules/Agenda/Agenda";
import TopicRecommendation from "@/router/modules/TopicRecommendation/TopicRecommendation";
import BodyView from "@/layout/bodyView.vue";
import indexDashboard from "@/pages/indexDashboard.vue";
import OwnerType from "@/router/modules/OwnerType/OwnerType";
// import Tag from "@/router/modules/Tag/Tag";
import DataAsset from "@/router/modules/DataAsset/DataAsset";
import Language from "@/router/modules/Language/Language";
import Translate from "@/router/modules/Translate/Translate";
// import Exception from "@/router/modules/Exception/Exception";
// import ExceptionSetting from "@/router/modules/ExceptionSetting/ExceptionSetting";

// User & Auth Routes
import User from "@/router/modules/User/User";
import AuthRoute from "@/router/modules/Auth/Auth";
import Permission from "@/router/modules/Permission/Permission";
import Auth from "@/API/Auth";
import { hasPermission } from "@/utils/helpers";
import { generatePermissionHash } from "@/utils/hash"; // Import your hash function

// Job & Department
import Job from "@/router/modules/Job/Job";
import Department from "@/router/modules/Department/Department";
import Hierarchy from "@/router/modules/Hierarchy/Hierarchy";
import Location from "@/router/modules/Location/Location";
import Role from "@/router/modules/Role/Role";
import Position from "@/router/modules/Position/Position";
import Team from "@/router/modules/Team/Team";
import Color from "@/router/modules/Color/Color";
import Rule from "@/router/modules/Rule/Rule";
import Incident from "@/router/modules/Incident/Incident";

import EmailConfig from "@/router/modules/EmailConfig/EmailConfig";
import Log from "@/router/modules/Log/Log";
import LogSetting from "@/router/modules/LogSetting/LogSetting";
import NotificationSetting from "@/router/modules/NotificationSetting/NotificationSetting";
// import Notification from "@/router/modules/notification/notification";
import AllNotification from "./modules/AllNotification/AllNotification";
import Cookies from "js-cookie";
import Errors from "./modules/Errors/Errors";
import AgendaDetails from "@/router/modules/AgendaDetails/AgendaDetails";
import AutomationRule from "@/router/modules/AutomationRule/AutomationRule";
import AutomationExecution from "@/router/modules/AutomationExecution/AutomationExecution";
import ClassificationTag from "@/router/modules/ClassificationTag/ClassificationTag";
import ClassifiedContent from "@/router/modules/ClassifiedContent/ClassifiedContent";
import InternalMessage from "@/router/modules/InternalMessage/InternalMessage";
import GeneralTask from "@/router/modules/GeneralTask/GeneralTask";
import Category from "@/router/modules/Category/Category";

import FrameworkInstall from "@/router/modules/FrameworkInstall/FrameworkInstall";
import InternalAuditResult from "@/router/modules/InternalAuditResult/InternalAuditResult";
import InternalAudit from "@/router/modules/InternalAudit/InternalAudit";
import ControlClass from "@/router/modules/ControlClass/ControlClass";
import ControlPhase from "@/router/modules/ControlPhase/ControlPhase";
import AuditPolicyCompliance from "@/router/modules/AuditPolicyCompliance/AuditPolicyCompliance";
import CenterPolicy from "@/router/modules/CenterPolicy/CenterPolicy";
import Document from "@/router/modules/Document/Document";
import DocumentCategory from "@/router/modules/DocumentCategory/DocumentCategory";
import WorkflowCategory from "@/router/modules/WorkflowCategory/WorkflowCategory";
import Regulator from "@/router/modules/Regulator/Regulator";
import Control from "@/router/modules/Control/Control";
import Domain from "@/router/modules/Domain/Domain";
import Requirement from "@/router/modules/Requirement/Requirement";
import Maturity from "@/router/modules/Maturity/Maturity";
import ControlType from "@/router/modules/ControlType/ControlType";
import Frameworks from "@/router/modules/Frameworks/Frameworks";
import Evidence from "@/router/modules/Evidence/Evidence";
import AuditRemidation from "@/router/modules/AuditRemidation/AuditRemidation";
import FrameworkControlTestAudit from "@/router/modules/FrameworkControlTestAudit/FrameworkControlTestAudit";
import AuditPlan from "@/router/modules/AuditPlan/AuditPlan";
import StandardLevel from "@/router/modules/StandardLevel/StandardLevel";
import StandardNdi from '@/router/modules/StandardNdi/StandardNdi';
import FrameworkDomainsTestAudit from '@/router/modules/FrameworkDomainsTestAudit/FrameworkDomainsTestAudit';
import AuditAssessmentActionsResult from '@/router/modules/AuditAssessmentActionsResult/AuditAssessmentActionsResult';
import GeneralRelation from '@/router/modules/GeneralRelation/GeneralRelation';


import Dashboard from "@/router/modules/Dashboard/Dashboard";
import UserReport from "@/router/modules/UserReport/UserReport";
import { useTranslations } from "@/composables/useTranslations"; 
import ServiceModelMap from "@/router/modules/ServiceModelMap/ServiceModelMap";
import DiaPiaManager from "@/router/modules/DiaPiaManager/DiaPiaManager";

declare const APP_NAME: string;

declare global {
  interface Window {
    routerData?: string;
  }
}

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: BodyView,
    meta: {
      title: "Default |  ",
    },
    children: [
      ...DiaPiaManager,
      ...Permission,
      ...User,
      ...Job,
      ...Department,
      ...Hierarchy,
      ...Location,

      ...Role,
      ...Team,
      ...Position,
      ...Rule,
      ...Color,
      ...Incident,
      ...NotificationSetting,
      // ...Notification,
      ...AllNotification,
      ...LogSetting,
      ...Log,
      ...EmailConfig,
      ...InternalMessage,
      ...GeneralTask,
      ...Category,

      // start indeom
      ...OwnerType,
      // ...Tag,
      ...Classification,
      ...ClassifiedContent,
      ...DataProduct,
      ...Glossary,
      ...Term,
      ...DomainControl,
      ...Domain,
      ...RequirementType,
      ...ObjectiveType,
      ...GlossaryUpdateRequest,
      ...GlossaryVersion,
      ...Objective,
      ...StrategicPlan,
      ...StrategicPlanDetails,
      ...ObjectiveDetails,
      ...Program,
      ...Initiative,
      ...ProgramDetails,
      ...Deliverable,
      ...DeliverableDetails,
      ...Task,
      ...TaskDetails,
      ...DataAsset,
      ...Project,
      ...ProjectDetails,
      ...Milestone,
      ...MilestoneDetails,
      ...InitiativeDetails,
      ...DatabaseServiceInsight,
      ...DatabaseService,
      ...DataCatalog,
      ...DatabaseInsights,
      ...DatabaseTables,
      ...DatabaseColumns,
      ...Reports,
      ...Topic,
      ...Committee,
      // ...Agenda,
      ...AgendaDetails,
      ...Meeting,
      ...TopicRecommendation,
      ...KpiModule.routes,
      ...Language,
      ...Translate,

      //DIA Request Module
      ...DIARequest,
      ...PIARequest,
      ...MitigationAction,

      // Automation
      ...AutomationRule,
      ...AutomationExecution,
      ...ClassificationTag,

      // ...ExceptionSetting,
      // ...Exception,
      ...ExportTemplate,

      ...Document,
      ...DocumentCategory,
      ...WorkflowCategory,
      ...FrameworkInstall,
      ...Regulator,
      ...Frameworks,
      ...Control,
      ...ControlType,
      ...Regulator,
      ...FrameworkInstall,
      ...Frameworks,
      ...Control,
      ...Requirement,
      ...Maturity,
      ...Evidence,
      ...AuditPlan,
      ...FrameworkControlTestAudit,
      ...AuditRemidation,
      ...CenterPolicy,
      ...AuditPolicyCompliance,
      ...ControlPhase,
      ...InternalAudit,
      ...InternalAuditResult,
      ...StandardLevel,
      ...StandardNdi,
      ...FrameworkDomainsTestAudit,
      ...AuditAssessmentActionsResult,

      ...Dashboard,
      ...UserReport,
      ...GeneralRelation,
      ...ServiceModelMap,
    ],
  },
  ...AuthRoute,
  ...Errors,
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Utility functions
function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? decodeURIComponent(match[2]) : null;
}

function base64UrlDecode(base64Url: string): string {
  let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const padding = base64.length % 4;
  if (padding) {
    base64 += "=".repeat(4 - padding);
  }
  return atob(base64);
}

function decodeJWT(token: string) {
  const parts = token.split(".");
  if (parts.length !== 3) {
    throw new Error("Invalid JWT format");
  }
  const header = JSON.parse(base64UrlDecode(parts[0]));
  const payload = JSON.parse(base64UrlDecode(parts[1]));
  return { header, payload };
}

// Function to get JWT token from cookies
function getTokenFromCookies(): string {
  let token = "";
  let i = 0;
  while (Cookies.get(`${APP_NAME}_api_token_part${i + 1}`)) {
    token += Cookies.get(`${APP_NAME}_api_token_part${i + 1}`);
    i++;
  }
  return token;
}

// Load translations before each route if mainTrKeys meta is present
// const SHARED_MODULES = ["common", "datatable", "menu"];

// router.beforeEach(async (to, from, next) => {
//   const modules: any = to.meta.mainTrKeys || [];

//   if (modules?.length == 0) {
//     const routeName: any = to?.name?.toString()?.toLocaleLowerCase();
//     //if the name is committe Details , delete the Details part
//     const mainKey = routeName.replace("details", "");
//     modules.push(mainKey);
//   }
//   // Always include shared modules
//   modules.push(...SHARED_MODULES);
//   if (modules && modules.length > 0) {
//     try {
//       const { loadMultipleModules } = useTranslations();
//       await loadMultipleModules(modules);
//     } catch (error) {
//       console.error("Failed to load translations:", error);
//     }
//   }

//   next();
// });


// Routes that don't require authentication
const publicRoutes = ["Login", "ForgotPassword"];

// Main authentication guard
router.beforeEach(async (to, from, next) => {
  try {
    // Skip authentication for routes marked with requiresAuth: false
    if (
      to.matched.some(
        (record) => record.meta && record.meta.requiresAuth === false
      )
    ) {
      return next();
    }

    // Check if user is authenticated
    const isAuthenticated = await Auth.loggedIn();

    if (
      isAuthenticated &&
      (to.name === "Login" || to.name === "ForgotPassword")
    ) {
      return next({ name: "home" });
    }

    // Allow public routes without authentication
    if (publicRoutes.includes(to.name as string)) {
      return next();
    }

    if (!isAuthenticated) {
      console.log("User not authenticated, redirecting to login");
      return next({ name: "Login" });
    }

    // Build controller path from route
    if (to.matched && to.matched.length > 1) {
      const component = to.matched[1];
      if (component && component.name && typeof component.name === "string") {
        const convertedPath = component.name
          .replace("/", "")
          .split("/")
          .map((part: string) => part.charAt(0).toUpperCase() + part.slice(1))
          .join("\\")
          .split("\\:id")
          .join("");

        // Extract the base module name from the route path for permission checking.
        // Detail/child routes like /risk/:id (name: "RiskView") should check the
        // base module "Risk", not "RiskView". We use the first path segment after "/".
        // Kebab-case paths (e.g. "third-party-profile") are converted to PascalCase ("ThirdPartyProfile").
        const pathSegments = (component.path || "").replace(/^\//, "").split("/").filter(Boolean);
        const baseModule = pathSegments.length > 0
          ? pathSegments[0]
              .split("-")
              .map((seg: string) => seg.charAt(0).toUpperCase() + seg.slice(1))
              .join("")
          : convertedPath;

        // Always set routerData to the base module controller for permission checks
        window.routerData = baseModule + "\\" + baseModule + "Controller\\";

        // Super admin has access to all routes
        if (Auth.isSuperAdmin()) {
          return next();
        }

        // Regular user - check permissions using role-based approach
        // 1) Check meta.permission if defined (supports "Model.action" format)
        const metaPerm = to.meta?.permission as string | undefined;
        if (metaPerm) {
          if (metaPerm.includes('.')) {
            const [model, action] = metaPerm.split('.');
            if (hasPermission(model, action || 'show')) {
              return next();
            }
          } else if (hasPermission(metaPerm, 'show')) {
            return next();
          }
          return next({ name: 'NotAuthorized' });
        }

        // 2) Try the base module first (e.g. "Risk" for /risk/:id),
        // then fall back to the full convertedPath (e.g. "RiskView")
        if (hasPermission(baseModule, "show") || hasPermission(convertedPath, "show")) {
          return next();
        } else {
          console.log("User does not have required permissions");
          return next({ name: "NotAuthorized" });
        }
      } else {
        return next({ name: "NotFound" });
      }
    } else {
      return next({ name: "NotFound" });
    }
  } catch (error) {
    console.error("Router guard error:", error);
    return next({ name: "Login" });
  }
});

// Update document title based on route meta
router.beforeEach((to) => {
  if (typeof to.meta?.title === "string") {
    document.title = to.meta.title;
  }
});


export default router;
